

import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const API_BASE = "https://api.mahal.qa/api";

const MahalDealsOfDay = () => {
  const [deals, setDeals] = useState([]);
  const [timers, setTimers] = useState({});
  const [cart, setCart] = useState({});
  const [loading, setLoading] = useState(true);
  const { t, i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const getProductName = (d) => {
    return isArabic ? d.title_ar || d.title : d.title;
  };

  const localizeNumber = (value) => {
  return new Intl.NumberFormat(isArabic ? "ar-QA" : "en-US").format(
    Number(value || 0)
  );
};

const localizeCurrency = (value) => {
  return isArabic
    ? `${localizeNumber(value)} ${t("qar")}`
    : `${t("qar")} ${localizeNumber(value)}`;
};
  /* ================= FETCH DEALS ================= */

  const fetchDeals = async () => {
    try {
      const res = await axios.get(
        "https://api.mahal.qa/api/deals-of-the-day"
      );

      let apiData = [];

      if (Array.isArray(res.data)) {
        apiData = res.data;
      } else if (res.data.products) {
        apiData = res.data.products;
      }

      const shuffled = [...apiData].sort(() => 0.5 - Math.random());
      const selected = shuffled.slice(0, 6);


      const formatted = selected.map((d) => ({
        id: d.id || d.product_id,
        title: d.name || d.product_name_english || "No Name",
        title_ar: d.name_ar || d.product_name_arabic || d.name || d.product_name_english || "No Name",
        img:
          d.img1 ||
          (d.product_id
            ? `https://api.mahal.qa/api/image/${d.product_id}/0`
            : "/fallback.png"),
        oldPrice: d.old_price || 0,
        price: d.price || d.price_per_unit || 0,
        endsIn: 5 * 60 * 60,
      }));

      setDeals(formatted);

      const t = {};
      formatted.forEach((d) => (t[d.id] = d.endsIn));
      setTimers(t);

    } catch (err) {
      console.error("❌ Deals fetch error:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDeals();
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      fetchDeals();
    }, 5 * 60 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimers((prev) => {
        const next = { ...prev };
        Object.keys(next).forEach((id) => {
          if (next[id] > 0) next[id] -= 1;
        });
        return next;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

const format = (s) => {
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;

  return isArabic
    ? `${localizeNumber(h)} ${t("hour")} ${localizeNumber(m)} ${t("minute")} ${localizeNumber(sec)} ${t("second")}`
    : `${h}h ${m}m ${sec}s`;
};

  /* ================= ADD TO CART ================= */

const addToCartAPI = (product) => {

  const token = localStorage.getItem("token");

  if (!token) {
    alert(t("please_login"));
    return;
  }

  axios
    .post(
      `${API_BASE}/cart/add`,
      {
        product_id: Number(product.id),
        quantity: 1,
        price: product.price,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )

    .then((res) => {

      // ✅ Product already exists
      if (res.data.status === "exists") {

alert(t("product_already_cart"));

      }

      // ✅ New product added
      else {

        alert(t("added_to_cart"));

      }

      console.log("Added to cart");

    })

    .catch((err) => {

      console.error(
        "ADD TO CART ERROR",
        err
      );

alert(err.response?.data?.error || t("backend_error"));

    });

};

  /* ================= UI CART ================= */

  const add = (d) => {
    addToCartAPI(d);
    setCart((p) => ({ ...p, [d.id]: (p[d.id] || 0) + 1 }));
  };

/* ================= REMOVE FROM CART API ================= */

/* ================= REMOVE ITEM ================= */

const removeFromCartAPI = async (item) => {

  try {

    const token = localStorage.getItem("token");

    if (!token) {
      alert(t("login_required"));
      return;
    }

    const currentQty = cart[item.id] || 1;

    const newQty = currentQty - 1;

    // =====================================
    // GET USER CART
    // =====================================

    const cartRes = await axios.get(
      `${API_BASE}/cart/me`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const cartItem = cartRes.data.items.find(
      (i) => i.product_id === item.id
    );

    if (!cartItem) {
      return;
    }

    // =====================================
    // REMOVE COMPLETELY
    // =====================================

    if (newQty <= 0) {

      await axios.delete(
        `${API_BASE}/cart/remove/${cartItem.cart_item_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setCart((prev) => {

        const updated = { ...prev };

        delete updated[item.id];

        return updated;

      });

    }

    // =====================================
    // UPDATE QUANTITY
    // =====================================

    else {

      await axios.put(
        `${API_BASE}/cart/update`,
        {
          cart_item_id: cartItem.cart_item_id,
          quantity: newQty,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setCart((prev) => ({
        ...prev,
        [item.id]: newQty,
      }));

    }

  } catch (err) {

    console.error(
      "❌ REMOVE ERROR:",
      err.response?.data || err
    );

  alert(err.response?.data?.error || t("failed_update_cart"));

  }

};

  if (loading) return <p>{t("loading_deals")}</p>;

  return (
   <div className="container mt-5" dir={isArabic ? "rtl" : "ltr"}>
      <div className="mm-deals-title">
<h2>{t("deals_of_the_day")}</h2>
<p>{t("limited_time_offers_verified_suppliers")}</p>
      </div>

      <div className="mm-deals-row">
        {deals.map((d) => (
          <div className="mm-deal-card" key={d.id}>

            {/* TIMER */}
            <div className="mm-timer">
              ⏰ {t("ends_in")} {format(timers[d.id] || 0)}
            </div>

            {/* IMAGE + EYE */}
            <div>
              <img
                src={d.img}
                alt={getProductName(d)}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = "/fallback.png";
                }}
              />

              <Link to={`/shopdetails/${d.id}`}>
                <i className="fa fa-eye"></i>
              </Link>
            </div>

            <h4>{getProductName(d)}</h4>

            {/* PRICE */}
          <div className="mm-price">
            <span className="old">{localizeCurrency(d.oldPrice)}</span>
            <span className="new">{localizeCurrency(d.price)}</span>
          </div>

            {/* CART */}
            {!cart[d.id] ? (
              <button
                className="mm-add"
                disabled={timers[d.id] === 0}
                onClick={() => add(d)}
              >
                {t("add_to_cart")}
              </button>
            ) : (
              <div className="mm-stepper">
                <button onClick={() => removeFromCartAPI(d)}>-</button>
                <span>{localizeNumber(cart[d.id])}</span>
                <button onClick={() => add(d)}>+</button>
              </div>
            )}

          </div>
        ))}
      </div>
    </div>
  );
};

export default MahalDealsOfDay;